<div class="container">
  <a href="https://www.facebook.com/drzewowisni" target="_blank">
    <img src="/assets/icons/facebook.png"  rel="nofollow" alt="Facebook" />
  </a>
  <a a href="https://www.instagram.com/sushidrzewowisni/" target="_blank">
    <img src="/assets/icons/instagram.png" rel="nofollow" alt="Instagram" />
  </a>
  <a
    a
    href="https://www.tripadvisor.com/Restaurant_Review-g274847-d23860828-Reviews-Sushi_Drzewo_WiSni-Poznan_Greater_Poland_Province_Central_Poland.html?m=19905"
    target="_blank"
  >
    <img src="/assets/icons/tripadvisor.png" rel="nofollow" alt="TripAdvisor" />
  </a>
  <a a href="https://goo.gl/maps/nYbbLSHmkj1XLj3AA" target="_blank">
    <img src="/assets/icons/google_maps.png" rel="nofollow" alt="GoogleMaps" />
  </a>
</div>
